/* tslint:disable */
/* eslint-disable */
/**
 * Registration App Tier Micro Service APIs
 * Registration App Tier Micro Service APIs
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface PersonalIdRequest
 */
export interface PersonalIdRequest {
  /**
   *
   * @type {string}
   * @memberof PersonalIdRequest
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof PersonalIdRequest
   */
  type?: PersonalIdRequestTypeEnum;
  /**
   * base64 encoded image data for validation or uploading.
   * @type {string}
   * @memberof PersonalIdRequest
   */
  documentData?: string;
}

/**
 * @export
 */
export const PersonalIdRequestTypeEnum = {
  Passport: 'PASSPORT',
  Cid: 'CID',
} as const;
export type PersonalIdRequestTypeEnum = (typeof PersonalIdRequestTypeEnum)[keyof typeof PersonalIdRequestTypeEnum];

/**
 * Check if a given object implements the PersonalIdRequest interface.
 */
export function instanceOfPersonalIdRequest(value: object): boolean {
  if (!('id' in value)) return false;
  return true;
}

export function PersonalIdRequestFromJSON(json: any): PersonalIdRequest {
  return PersonalIdRequestFromJSONTyped(json, false);
}

export function PersonalIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalIdRequest {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    type: json['type'] == null ? undefined : json['type'],
    documentData: json['documentData'] == null ? undefined : json['documentData'],
  };
}

export function PersonalIdRequestToJSON(value?: PersonalIdRequest | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    type: value['type'],
    documentData: value['documentData'],
  };
}
